// JELSZÓ-POLICY blokk: a statikus szabály-hint + a SZERVER által visszaadott sértések LOKALIZÁLT szövege.
//
// MIÉRT KÖZÖS: a policy autoritása az Odin (min. 12 karakter, kis+nagy+szám), és a 422 GÉPI KÓDOKAT ad
// (`too_short`, `missing_uppercase`, …). Ugyanezt kell megjelenítenie a jelszó-beállító lapnak és az „Új
// munkatárs" űrlap kezdő-jelszó mezőjének — a második helyen ez már copy-paste lett volna. Az i18n-kulcsok
// ezért a `common.passwordPolicy*` alatt élnek (nem lap-specifikus névtérben).
//
// SZABÁLY: ismeretlen kód → a GENERIKUS szöveg (`invalid`), SOHA nem a nyers kulcs/kód. A szerver bármikor
// bevezethet új policy-szabályt; a felület akkor sem mutathat gépi kódot a felhasználónak.
import { useTranslation } from 'react-i18next';

export interface PasswordPolicyNoteProps {
  /** A szerver policy-kódjai (üres tömb → csak a statikus hint látszik). */
  codes?: string[];
  /** Elhagyható a statikus hint (ha a mezőnek már van saját, bővebb `hint`-je). */
  hideHint?: boolean;
}

export function PasswordPolicyNote({
  codes = [],
  hideHint = false,
}: PasswordPolicyNoteProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <>
      {!hideHint && (
        <p className="text-muted-foreground text-xs">{t('common.passwordPolicyHint')}</p>
      )}
      {codes.map((code) => (
        <p key={code} className="text-destructive text-xs">
          {t(`common.passwordPolicy.${code}`, { defaultValue: t('common.passwordPolicy.invalid') })}
        </p>
      ))}
    </>
  );
}
